import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators,FormGroupDirective} from '@angular/forms';
import { ApiService } from '../api.service';
import { ObservablesService } from '../observables.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Subject } from "rxjs";
import {Observable} from 'rxjs';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import {map, startWith} from 'rxjs/operators';
import { _ } from 'underscore';
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {default as _rollupMoment} from 'moment';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-invoice-form',
  templateUrl: './invoice-form.component.html',
  styleUrls: ['./invoice-form.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
 ],
})
export class InvoiceFormComponent implements OnInit, OnDestroy{
  myControl = new FormControl('', Validators.required);
  parties:any = []
  options:any = []
  filteredOptions: Observable<string[]>;
  catOptions: Observable<any[]>[][] = [];
  itemOptions: Observable<string[]>[][] = [];
  // itemOptions: Observable<any[]>[] = [];
  saveUnsuccess: boolean;
  serializedDate = new FormControl((new Date()).toISOString());
  itemDetails:any=[];
  items:any=[];
  invoiceForm: FormGroup;
  // slip_date: string | number | Date;
  amount: any=0;
  totamt: number=0;
  gst_total_amt:number = 0;
  iterateSubscriber:any;
  iterationObserver:any = new Subject<any>();
  patchSubscriber:any;
  patchObserver:any = new Subject<any>();
  unitVariableIterateSubscriber:any;
  unitVariableIterationObserver:any = new Subject<any>();
  deleteUnitVariableIterateSubscriber:any;
  deleteUnitVariableIterationObserver:any = new Subject<any>();
  arrayUnitVariableIterateSubscriber:any;
  arrayUnitVariableIterationObserver:any = new Subject<any>();
  tagIterateSubscriber:any;
  tagIterationObserver:any = new Subject<any>();
  editIterateSubscriber:any;
  editIterationObserver:any = new Subject<any>();
  editProductIterateSubscriber:any;
  editProductIterationObserver:any = new Subject<any>();
  updateCategoryIterateSubscriber:any;
  updateCategoryIterationObserver:any = new Subject<any>();
  deleteCategoryIterateSubscriber:any;
  deleteCategoryIterationObserver:any = new Subject<any>();
  updateProductIterateSubscriber:any;
  updateProductIterationObserver:any = new Subject<any>();
  deleteProductIterateSubscriber:any;
  deleteProductIterationObserver:any = new Subject<any>();
  masterProductIterateSubscriber:any;
  masterProductIterationObserver:any = new Subject<any>();
  masterCategoryIterateSubscriber:any;
  masterCategoryIterationObserver:any = new Subject<any>();
  masterVariablesIterateSubscriber:any;
  masterVariablesIterationObserver:any = new Subject<any>();
  masterInvoiceProductsIterateSubscriber:any;
  masterInvoiceProductsIterationObserver:any = new Subject<any>();
  prepareProductsIterateSubscriber:any;
  prepareProductsIterationObserver:any = new Subject<any>();
  productSubscriber:any;
  editInvoiceSubscriber:any;
  editInvoiceInfo:any={editStatus:false,data:{direct_invoice_status:0}};
  DeletedCategoryRows:any=[]
  DeletedProductRows:any=[]
  DeletedUnitVariableRows:any=[]
  editOnceStatus:boolean=false
  editStatus: boolean = false;
  existingInvoiceStatus: boolean = false;
  productObserver:any = new Subject<any>();
  editInvoiceId:any=''
  selectedParty:any=null;
  user_id:any;
  loggedUserInfo:any=[]
  units:any=[]
  business_id:any;
  parent_id:any;
  refreshTagsSubscriber:any;
  tags:any=[]
  editTags:any=[]
  party_gstin:any=null;
  productDetails:any=[];
  loadingStatus:boolean = false
  constructor(private router:Router, private observables:ObservablesService,private formBuilder: FormBuilder, private api:ApiService, private datePipe: DatePipe) {
    if(this.router.getCurrentNavigation().extras.state !== undefined){
      this.editInvoiceInfo = this.router.getCurrentNavigation().extras.state
      // console.log("editInvoiceInfo=",this.editInvoiceInfo)
    }
  }
  ngOnInit() {
    this.refreshTagsSubscriber = this.observables.refreshTagsStatus.subscribe(()=>{
      this.getTags();
    })

    if(this.editInvoiceInfo.data.direct_invoice_status == 0){
      this.api.getLoggedUserInfo().then((res:any)=>{
        if(res.data.length > 0){
          this.loggedUserInfo = res.data[0];
          if(this.loggedUserInfo.level == 1){
            this.business_id = this.loggedUserInfo.business_id
            this.user_id = this.loggedUserInfo.id
          }else if(this.loggedUserInfo.level > 1){
            this.user_id = this.loggedUserInfo.id
            this.parent_id = this.loggedUserInfo.parent_id
            this.business_id = this.loggedUserInfo.business_id
          }else{
            this.api.logOut()
          }

          this.getParty();
          this.getItem();
          if(this.loggedUserInfo.tag_subscribe_status){
            this.getTags();
          }

          this.getUnit()

          if(!this.editInvoiceInfo.editStatus) {
            this.getLastInvoiceId();

          }
        }

      })
      this.createForm()
    }
  }

  onTabChange(event){
    this.getLastInvoiceId()
  }

  getUnit(){
    this.api.send('findDb',{
      table:'units'
    }).then((res:any)=>{
      this.units = res.data;
    })
  }

  getItemUnit(unit_id){
    return this.units.filter(unit=>unit.id==unit_id)
  }


  getTag(tag_id){
    for(let i=0;i<this.tags.length;i++){
      if(this.tags[i].id == tag_id){
        return this.tags[i].tag_name
      }
    }
  }

  createForm(){
    // console.log("this.editInvoiceInfo",this.editInvoiceInfo)
    if(!this.editInvoiceInfo.editStatus) {

      this.editStatus = false;
      this.editOnceStatus = false;
      this.invoiceForm = this.formBuilder.group({
        invoice_number:[{value:''}, Validators.compose([Validators.required,Validators.pattern(/^[0-9]{1,6}$/)])],
        party_id:[null, Validators.required],
        user_id:[null],
        party_name:[null, Validators.required],
        invoice_date:{value:moment(),disabled:true},
        delivery_to:null,
        total_amount: [{value:this.totamt,disabled:true}, Validators.required],
        gst_total_amount:this.gst_total_amt,
        categories: this.formBuilder.array([this.categories]),
        tags:[null],
        note:[null]
      });

      this.manageCategoryControl(0,((this.invoiceForm.get("categories") as FormArray).at(0) as FormGroup),0)
      this.ManageNameControl(0,((this.invoiceForm.get("categories") as FormArray).at(0) as FormGroup),0)
      // this.getLastInvoiceId()

    }else{
      if(!this.editOnceStatus){
        this.editInvoice()
      }
    }

  }

  editInvoice(){
    if(this.editInvoiceInfo.editStatus){
      this.editOnceStatus = true;
      this.editStatus = true;
      this.DeletedCategoryRows=[];
      this.DeletedProductRows=[];
      this.editInvoiceId = this.editInvoiceInfo.data.id;

      this.invoiceForm = this.formBuilder.group({
        invoice_number:[{value:this.editInvoiceInfo.data.invoice_number,disabled:true}, Validators.required],
        party_id:this.editInvoiceInfo.data.party_id,
        user_id:this.editInvoiceInfo.data.user_id,
        party_name:this.editInvoiceInfo.data.business_name,
        invoice_date:{value:new Date(this.editInvoiceInfo.data.invoice_date),disabled:true},
        delivery_to:this.editInvoiceInfo.data.delivery_to,
        total_amount: [{value:this.editInvoiceInfo.data.total_amount,disabled:true}, Validators.required],
        gst_total_amount:this.editInvoiceInfo.data.gst_total_amount,
        categories: this.formBuilder.array([this.categories]),
        tags:[null],
        note:this.editInvoiceInfo.data.note
      });

      this.editTags=[]
      this.api.send("findDb",{
        table:"slip_invoice_tags",
        conditions:[{invoice_id:this.editInvoiceInfo.data.id}]
      }).then((res:any)=>{
        if(res.data.length > 0){
          for(let i=0;i<res.data.length;i++){
            this.editTags.push(res.data[i].tag_id)
            if(i==res.data.length -1){

              this.invoiceForm.patchValue({tags:this.editTags})
              // console.log("tags=",tags)
            }
          }
        }
      })


      this.api.send("findDb",{
        table:"categories",
        conditions:[{invoice_id:this.editInvoiceInfo.data.id}]
      }).then((res:any)=>{
        if(res.data.length > 0){
          this.getCategories(res.data)
        }
      })
    }

  }

  getCategories(categories){
    let k=0;
    this.manageCategoryControl(0,((this.invoiceForm.get("categories") as FormArray).at(0) as FormGroup),0);
    this.editIterateSubscriber = this.editIterationObserver.subscribe((k)=>{
      if(k>=categories.length){
        this.editIterateSubscriber.unsubscribe()
      }else{
        (<FormArray>this.invoiceForm.controls['categories']).at(k).patchValue({'category_id':categories[k].id,'category_name':categories[k].category_name});
        this.api.send("findDb",{
          table:"product_details as P",
          fields:["P.*","I.name","I.gst","I.rate as item_rate","I.unit_id","I.cess","I.hsn_code"],
          joins:[{
            type:"left",
            table:"items as I",
            conditions:["I.id = P.item_id"]
          }],
          conditions:[{"P.category_id":categories[k].id,"P.invoice_id":this.editInvoiceInfo.data.id}],
          order:"id ASC"
        }).then((res1:any)=>{
          if(res1.data.length > 0){
            this.getProducts(res1.data,k).then((status)=>{

              if(status){
                if(k+1 == categories.length){
                  this.editIterationObserver.next(k+1)
                }else{
                  this.addCategory().then(()=>{
                    this.editIterationObserver.next(k+1)
                  })

                }

              }
            })
          }
        })

      }
    })

    this.editIterationObserver.next(k)
  }

  getProducts(products,i){
    return new Promise((resolve)=>{
      let k=0;
      this.ManageNameControl(k,((this.invoiceForm.get("categories") as FormArray).at(i) as FormGroup),i);
      const controls = ((this.invoiceForm.get("categories") as FormArray).at(i).get("products") as FormArray);
      this.editProductIterateSubscriber = this.editProductIterationObserver.subscribe((k)=>{
        if(k>=products.length){
          this.editProductIterateSubscriber.unsubscribe()
          resolve(true);
        }else{

          // console.log("products[k]=",products[k])

            controls.at(k).patchValue(
              {
                product_id:products[k].id,
                qty:products[k].qty,
                description:products[k].description,
                hsn_code:products[k].hsn_code,
                rate:products[k].rate,
                amount:products[k].amount,
                item:products[k].item_id,
                item_name:products[k].name,
                item_code:products[k].item_code,
                gst:products[k].gst,
                unit_id:products[k].unit_id,
                discount:products[k].discount
              }
            )

            // -----------------------------------

            this.api.send("findDb",{
              fields:["P.*","U.*","P.id as product_unit_variable_id"],
              table:"product_unit_variables as P",
              joins:[{
                type:"left",
                table:'unit_variables as U',
                conditions:["U.id = P.unit_variable_id"]
              }],
              conditions:[{"P.product_detail_id":products[k].id}],
              order:"P.unit_variable_id ASC"
            }).then((res:any)=>{
              let item = this.items.filter(item=>item.id == products[k].item_id)
              // console.log("item=",item)
              this.manageVariableControl(controls.at(k),item[0])
              // console.log("res====",res.data)

              // for(let i=0;i<this.items.length;i++){
              //   if(this.items[i].id == products[k].item_id){
              //     this.manageVariableControl(controls.at(k),this.items[i])
              //   }
              // }
              if(res.data.length > 0){
                this.patchValues(res.data,controls,k).then((patchRes:any)=>{
                  this.calculateTotal(k,i,((this.invoiceForm.get("categories") as FormArray).at(i) as FormGroup),controls.at(k));
                  if(k+1 == products.length){

                    this.editProductIterationObserver.next(k+1)
                  }else{
                    this.addProduct(((this.invoiceForm.get("categories") as FormArray).at(i) as FormGroup),i);
                    this.editProductIterationObserver.next(k+1)
                  }
                })


              }else{
                if(k+1 == products.length){

                  this.editProductIterationObserver.next(k+1)
                }else{
                  this.addProduct(((this.invoiceForm.get("categories") as FormArray).at(i) as FormGroup),i);
                  this.editProductIterationObserver.next(k+1)
                }
              }
            })

            // this.patchItemValue(products[k].item_id,controls,k)
          }

      })

      this.editProductIterationObserver.next(k)
    })
  }

            //----------------------------
  // ***********************

  //           if(k+1 == products.length){
  //
  //             this.editProductIterationObserver.next(k+1)
  //           }else{
  //             this.addProduct(((this.invoiceForm.get("categories") as FormArray).at(i) as FormGroup),i);
  //             this.editProductIterationObserver.next(k+1)
  //           }
  //
  //
  //         }
  //
  //     })
  //
  //     this.editProductIterationObserver.next(k)
  //   })
  // }

  //*********************************************

  // --------------------------------------------
  patchValues(data,controls,k){
    // console.log("data==",data)
    // console.log("controls==",controls)
    return new Promise((resolve)=>{
      let a = 0;

      this.patchSubscriber = this.patchObserver.subscribe((a:any)=>{
        if(a>=data.length){
          this.patchSubscriber.unsubscribe()
          resolve(true)
        }else{

          // console.log("form==",(controls.at(k).get('demoArray') as FormArray));
          // console.log("value=",data[a].name +"-"+data[a].unit_variable_value);
          (controls.at(k).get('demoArray') as FormArray).at(a).patchValue({
            product_variable_id:data[a].product_unit_variable_id,
            [data[a].name]:data[a].unit_variable_value,
            unit_variable_id:data[a].unit_variable_id
          });
          this.patchObserver.next(a+1)
        }
      })
      this.patchObserver.next(a)
    })
  }

  manageEditVariableControl(product,itemData){
    const control = (this.invoiceForm.get('categories') as FormGroup);
    product.setControl('demoArray', this.formBuilder.array([]));

    for(let k=0;k<itemData.unit_variables.length;k++){
      this.addEditItem(itemData.unit_variables[k].unit_variable,itemData.unit_variables[k].unit_variable_id,product,k)

      if(k == itemData.unit_variables.length - 1){
        this.addEditUnitToForm(product,itemData.unit,k+1)
        // console.log("productControl==",productControl)
      }
    }


  }

  addEditUnitToForm(product,item,k=0){
    product.get('demoArray').push(this.arrayGroup({[item]:new FormControl({value:0,disabled:true}, Validators.required)}))
    product.get('demoArray').controls[k].key = item
  }

  addEditItem(item,item_id,product,k) {
     // this.arrayItems.push(item);
     product.get('demoArray').push(
       this.arrayGroup({[item]:new FormControl(0, Validators.required),
       unit_variable_id:new FormControl(item_id, Validators.required)})
     )
     product.get('demoArray').controls[k].key = item
  }

  // private arrayEditGroup(data): FormGroup {
  //   return this.formBuilder.group(data);
  // }

  // -----------------------------------------------

  // patchItemValue(item_id,control,i){
  //   let a = (control.get("products") as FormArray);
  //    this.items.filter((item:any)=>{
  //     if(item.id == item_id){
  //         control.at(i).patchValue({item_name:item.name,gst:item.gst})
  //     }
  //   })
  // }

  ngOnDestroy(){
    this.refreshTagsSubscriber.unsubscribe();
  }

  get categories(): FormGroup {
    return this.formBuilder.group({
      category_id:"",
      category_name: "",
      products: this.formBuilder.array([this.products])
    });
  }

  get products(): FormGroup {
    return this.formBuilder.group({
      product_id:'',
      item_name: [null, Validators.required],
      item_code: [null],
      item: [null, Validators.required],
      hsn_code:[null],
      description:[null],
      demoArray: this.formBuilder.array([]),
      qty:[null, Validators.required],
      rate:[null, Validators.compose([Validators.required, Validators.pattern(/^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/)])],
      amount: [{value:0,disabled:true}, Validators.required],
      unit_id:[null],
      discount:[null, Validators.compose([Validators.pattern(/^(100|[0-9]{1,2})?$/)])],
      gst:[null, Validators.compose([Validators.required,Validators.pattern(/^(100|[0-9]{1,2})?$/)])]
    });
  }

  checkInvoiceNo(value){
    // console.log("Slip no= : ",value);
    // return new Promise((resolve)=>{

    if(value.length > 0){
      let data={
        invoice_number:value,
        business_id:this.loggedUserInfo.business_id
      }

      this.api.send("findDb",{
        table:"master_invoices",
        conditions:[data]
      }).then((result:any)=>{
        // console.log("Invoice No==",result)
        if(result.data.length > 0){

          this.existingInvoiceStatus = true;
          // resolve(true)
        }else{
          this.existingInvoiceStatus = false;
          // resolve(false)
        }
      })
    }else{
      this.existingInvoiceStatus = false;
      // resolve(false)
    }
    // })

  }

  getLastInvoiceId(){
    this.api.send("findDb",{
      fields:["invoice_number"],
      table:"master_invoices",
      conditions:[{business_id:this.business_id}],
      order:"invoice_number DESC",
      limit:1
    }).then((res:any)=>{
      if(res.data.length > 0){

        this.invoiceForm.patchValue({invoice_number:parseInt(res.data[0].invoice_number) + 1})
        this.observables.setInvoiceNumberStatus.next({invoice_number:res.data[0].invoice_number})
      }else{
        this.invoiceForm.patchValue({invoice_number:1})
      }
    })
  }

  calculateTotal(i,j,category,product){
    // console.log("product===============")
    const control1 = category.get("products");
    const control = this.invoiceForm.getRawValue()['categories'][j]['products'];
    // console.log("product=",product)
    let demoArrayControl = product.get('demoArray').controls;
    // console.log("demoArrayControl===============",demoArrayControl)
    let result = []
    // if(demoArrayControl.length > 2){

      for(let k=0;k<demoArrayControl.length -1;k++){
  
        result.push(demoArrayControl[k].value[demoArrayControl[k].key])
      }
    // }else if(demoArrayControl.length == 2){
    //   result.push(demoArrayControl[0].value[demoArrayControl[0].key])
    // }

    // console.log("result=",result)
 
    let abc = result.reduce( ( accumulator, currentValue ) => {
      return accumulator*currentValue
    }, 1);

    let demoArrayLength = control[i].demoArray.length;
    // console.log("control=",control[0].demoArray[control[0].demoArray.length - 1])
    let unit_name = Object.keys(control[i].demoArray[demoArrayLength - 1])[0]
    // control.patchValue({[unit_name]:abc})
    // console.log("unit_name=",unit_name)
    // console.log("abc===============",abc)
    // console.log("parseFloat((abc*0.000001).toFixed(2)===============",parseFloat((abc*0.000001).toFixed(2)))
    // console.log("last key=",unit_name)
    let discount = product.value.rate/100*product.value.discount;
    // console.log("discount=",discount)
    let actualAmount:any = 0
    // let actualAmount:any = (control[i].qty*control[i].rate);
    // console.log("product==",product)
    if(demoArrayControl.length > 2){
      actualAmount = ((parseFloat((abc*0.000001).toFixed(2))*product.value.qty)*(product.value.rate - discount));
      product.get('demoArray').controls[demoArrayControl.length -1].patchValue({[unit_name]:parseFloat((abc*0.000001).toFixed(2))})
    }else if(demoArrayControl.length == 2){
      actualAmount = ((parseFloat((abc*1).toFixed(2))*product.value.qty)*(product.value.rate - discount));
      product.get('demoArray').controls[demoArrayLength-1].patchValue({[unit_name]:parseFloat((abc*1).toFixed(2))})
    }
    
    product.patchValue({amount:actualAmount.toFixed(2)})
    //
    // console.log("arrayDemo=",product.get('demoArray').controls[demoArrayLength-1])
    this.calculateTotalAmount()
    this.calculateGSTTotalAmount()

  }
  // **********************************
  // calculateTotal(i,j,category,product){
  //
  //   const control1 = category.get("products");
  //   const control = this.invoiceForm.getRawValue()['categories'][j]['products'];
  //
  //   let actualAmount:any = (control[i].qty*control[i].rate);
  //   control1.at(i).patchValue({amount:actualAmount.toFixed(3)})
  //
  //   this.calculateTotalAmount()
  //   this.calculateGSTTotalAmount()
  //
  // }
  // **********************************

  calculateTotalAmount(){
    let total = 0;

    for(let i =0;i<this.invoiceForm.getRawValue()['categories'].length;i++){
      total = total + this.invoiceForm.getRawValue()['categories'][i]['products'].reduce( ( accumulator, currentValue ) => {
        return accumulator + parseFloat(currentValue.amount);
      }, 0);

      this.invoiceForm.patchValue({total_amount:total.toFixed(3)})
    }

  }
  calculateGSTTotalAmount(){
    let total = 0;

    for(let i =0;i<this.invoiceForm.getRawValue()['categories'].length;i++){
      total = total + this.invoiceForm.getRawValue()['categories'][i]['products'].reduce( ( accumulator, currentValue ) => {

        return accumulator + (currentValue.amount*currentValue.gst)/100;

      }, 0);

      this.invoiceForm.patchValue({gst_total_amount:total.toFixed(3)});

    }

  }

  getParty(){

   this.api.send("findDb",{
     table:"parties",
     conditions:[{business_id:this.business_id}],
     order:"id DESC"
   }).then((result:any)=>{
     // console.log("results=",result)
     this.parties = result.data;
     this.options = result.data;

     this.filteredOptions = this.invoiceForm.get('party_name').valueChanges
     .pipe(
       startWith(''),
       map(value => this._filter(value))
     );
   });

  }

  private _filter(value: any): string[] {
    if(value){

      const filterValue = value.toLowerCase();
      return this.options.filter(option => option.business_name.toLowerCase().includes(filterValue));
    }
  }


    onSelectionChanged(_event: any,userData) {

      if (_event.isUserInput) {

        this.invoiceForm.patchValue({party_id:userData.id,user_id:userData.user_id})
        this.party_gstin = userData.gstin;
      }

    }

// ------------------------
    onSelectionChanged1(_event: any,itemData,i,category,j,product) {
      if(_event.isUserInput){
        // console.log("category",category)
        // console.log("product===============",product)
        // console.log("itemData",itemData)
          if(product.value.item != itemData.id){

            const control = category.get("products");

            let a = (category.get("products") as FormArray);


            this.items.filter((item:any)=>{
              if(item.id == itemData.id){
                control.at(i).patchValue({item:item.id,item_code:item.item_code,unit_id:item.unit_id,gst:item.gst,hsn_code:item.hsn_code, rate:item.rate,qty:item.qty,description:item.description,amount:0,discount:item.discount})
                if(itemData.unit_variables.length > 0){
                  if(product.value.product_id == ''){

                    this.manageVariableControl(product,itemData)
                  }else{
                    this.manageVariableControl(product,itemData,true)
                  }
                }else{
                  this.addUnitToForm(product,itemData.unit)
                }
              }
            })

            this.calculateTotalAmount()
            this.calculateGSTTotalAmount()
          }else{
            console.log("same item selected=")
          }
      }
    }

    manageVariableControl(product,itemData,updateStatus=false){
      // const productControl = (product.get("demoArray") as FormArray);
      // const productControl = product.get("demoArray")
      if(updateStatus){

        // console.log("product ==",product)
        for(let i=0;i<product.value.demoArray.length;i++){

          // console.log("product id==",product.value.demoArray[i].product_variable_id)
          this.DeletedUnitVariableRows.push(product.value.demoArray[i].product_variable_id)
        }
      }

      const control = (this.invoiceForm.get('categories') as FormGroup);
      product.setControl('demoArray', this.formBuilder.array([]));

      for(let k=0;k<itemData.unit_variables.length;k++){
        this.addItem(itemData.unit_variables[k].unit_variable,itemData.unit_variables[k].unit_variable_id,product,k)

        if(k == itemData.unit_variables.length - 1){
          this.addUnitToForm(product,itemData.unit,k+1)
          // console.log("productControl==",productControl)
        }
      }


    }

    addUnitToForm(product,item,k=0){
      product.get('demoArray').push(this.arrayGroup({[item]:new FormControl({value:1,disabled:true}, Validators.required)}))
      product.get('demoArray').controls[k].key = item
    }

    addItem(item,item_id,product,k) {
       // this.arrayItems.push(item);
       product.get('demoArray').push(
         this.arrayGroup({
           product_variable_id:new FormControl(''),
           key:new FormControl(`${item}`),
           [item]:new FormControl(0, Validators.compose([Validators.required, Validators.pattern(/^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/)])),
           unit_variable_id:new FormControl(item_id, Validators.required)
         })
       )
       product.get('demoArray').controls[k].key = item
    }

    private arrayGroup(data): FormGroup {
      return this.formBuilder.group(data);
    }

    //----------------------

    // ****************************
    // onSelectionChanged1(_event: any,itemData,i,category,j) {
    //   if(_event.isUserInput){
    //       const control = category.get("products");
    //       let a = (category.get("products") as FormArray);
    //        this.items.filter((item:any)=>{
    //         if(item.id == itemData.id){
    //           control.at(i).patchValue({item:item.id,unit_id:item.unit_id,gst:item.gst,rate:item.rate,qty:null,description:null,amount:0})
    //         }
    //       })
    //
    //       this.calculateTotalAmount()
    //       this.calculateGSTTotalAmount()
    //   }
    // }

    // ****************************

    manageCategoryControl(i,category,j){
      this.itemOptions[j] = []
    }


     ManageNameControl(index: number,category,j) {

      const mainFormControl = (this.invoiceForm.get("categories") as FormArray);

       this.itemOptions[j][index]=(mainFormControl.at(j).get("products") as FormArray).at(index).get('item_name').valueChanges
      .pipe(
        startWith(''),
        map(value => this._filters(value))
      );
    }

    private _filters(value: any): string[] {
      if(value){

        const filterValue = value.toLowerCase();
        return this.items.filter(option => option.name.toLowerCase().includes(filterValue));
      }

    }

    getItem(){
      this.items= []
       this.api.send("findDb",{
         table:"items as I",
         fields:["U.name as unit","U.id as unit_id","UV.name as unit_variable","IU.unit_variable_id","I.*"],
         joins:[{
           type:'left',
           table:'item_unit_variables as IU',
           conditions:["IU.item_id = I.id"]
         },{
           type:'left',
           table:'unit_variables as UV',
           conditions:["UV.id = IU.unit_variable_id"]
         },{
           type:'left',
           table:'units as U',
           conditions:["U.id = I.unit_id"]
         }],
         conditions:[{"I.business_id":this.business_id}]
       }).then((result:any)=>{
         let group = _.groupBy(result.data,'id')
         let value = _.values(group);

         value.filter((item)=>{
          if(item.length > 1){
            let unit_variables=[]

            for(let i=0;i<item.length;i++){
              unit_variables.push({unit_variable:item[i].unit_variable,unit_variable_id:item[i].unit_variable_id})

              if(i == item.length -1){

                this.items.push({
                  business_id: item[0].business_id,
                  cess: item[0].cess,
                  discount: item[0].discount,
                  gst: item[0].gst,
                  id: item[0].id,
                  name: item[0].name,
                  item_code:item[0].item_code,
                  rate: item[0].rate,
                  hsn_code:item[0].hsn_code,
                  unit:item[0].unit,
                  unit_id:item[0].unit_id,
                  unit_variables: unit_variables,
                  unit_variable_name:Array.prototype.map.call(unit_variables, s => s.unit_variable).toString()
                  // unit_id:item[0].unit_id
                })
              }
            }
          }else{

            this.items.push({
              business_id: item[0].business_id,
              cess: item[0].cess,
              discount: item[0].discount,
              gst: item[0].gst,
              id: item[0].id,
              name: item[0].name,
              item_code:item[0].item_code,
              rate: item[0].rate,
              hsn_code:item[0].hsn_code,
              unit:item[0].unit,
              unit_id:item[0].unit_id,
              unit_variables: [{unit_variable:item[0].unit_variable,unit_variable_id:item[0].unit_variable_id}],
              unit_variable_name:item[0].unit_variable
            })
          }
       })

     })
    }

    //************
  // getItem(){
  //  this.api.send("findDb",{
  //    table:"items",
  //    conditions:[{business_id:this.business_id}]
  //  }).then((result:any)=>{
  //    this.items=result.data
  //  })
  // }
  //************

  getTags(){
   this.api.send("findDb",{
     table:"tags",
     conditions:[{business_id:this.business_id}]
   }).then((result:any)=>{
     this.tags=result.data
   })
  }

  addTags(){
      this.observables.tagPopupStatus.next()
  }


  addCategory(status = false) {
    return new Promise((resolve)=>{
      const control = (this.invoiceForm.get("categories") as FormArray);
      control.push(this.categories);
      this.manageCategoryControl(0,(control.at(control.controls.length-1) as FormGroup),control.controls.length-1)
      if(status){

        this.ManageNameControl(0,(control.at(control.controls.length-1) as FormGroup),control.controls.length-1)
      }

      resolve(true);
    })
  }

  removeCategory(item,categories,category,deleteID): void {

    if(confirm("Are you sure to remove Category and its Associate Products?")){

      if(deleteID != ''){
        this.DeletedCategoryRows.push(deleteID)
      }


      if(categories.value.length - 1 == item){
        (this.invoiceForm.get("categories") as FormArray).removeAt(item);
        this.manageCategoryControl(item-1,categories,item);
      }else{
        (this.invoiceForm.get("categories") as FormArray).removeAt(item);
        console.log((this.invoiceForm.get("categories") as FormArray).value[item].products);
        for(let i=item;i<(this.invoiceForm.get("categories") as FormArray).value.length;i++){

          for(let j=0;j<(this.invoiceForm.get("categories") as FormArray).value[i].products.length;j++){

            this.ManageNameControl(j,category,i)
          }
        }
      }


      this.calculateTotalAmount();
      this.calculateGSTTotalAmount();
    }
  }
  addProduct(category,j): void {

    category.get("products").push(this.products);
    this.ManageNameControl(category.value.products.length - 1,category,j);
  }
  removeProduct(item,category,categoryId,deleteID,j): void {
    if(confirm("Are you sure to remove this Product?")){

      if(deleteID != '' && categoryId != ''){
        this.DeletedProductRows.push({product_id:deleteID,category_id:categoryId})
      }
      if(category.value.products.length - 1 == item){
        category.get("products").removeAt(item);
        this.ManageNameControl(item-1,category,j);
      }else{
        category.get("products").removeAt(item);
        this.ManageNameControl(item,category,j);
      }

      this.calculateTotalAmount()
      this.calculateGSTTotalAmount()
    }
  }

  // checkUser() {
  //
  //     if (!this.selectedParty || this.selectedParty.full_name !== this.invoiceForm.get('party_name').value) {
  //       this.invoiceForm.get('party_name').setValue(null);
  //       this.selectedParty = null;
  //     }
  //   }

  submitData(formValue,formDirective:FormGroupDirective,printStatus){
    this.loadingStatus = true;
    let value = this.invoiceForm.getRawValue();
    console.log("value=",value)
  
    this.productDetails = []
    let date:any = new Date(value.invoice_date);
    let invoice_date:any=this.datePipe.transform(date, 'yyyy-MM-dd'); //whatever format you need.

    this.api.send("insertDb",{
      table:"invoices",
      data:{
        business_id:this.business_id,
        invoice_number:value.invoice_number,
        party_id:value.party_id,
        invoice_date:invoice_date,
        gst_total_amount:value.gst_total_amount,
        exclude_gst_total_amount: value.total_amount,
        total_amount: parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
        balance:  parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
        delivery_to: value.delivery_to,
        user_id:value.user_id,
        note:value.note
      }
    }).then((result:any)=>{
      if(result.data.affectedRows){
        this.addToMaster(value,invoice_date,result.data.insertId).then((resp:any)=>{
          if(resp.status){
            this.productDetails.push({master_invoice_id:resp.master_invoice_id,categories:[]})
            this.saveCategory(value.categories,result.data.insertId).then((categoryRes:any)=>{

              if(categoryRes){
                if(value.tags){
                  this.saveTags(value.tags,result.data.insertId).then((tagRes:any)=>{
                    // this.resetAll(formDirective,printStatus,result.data.insertId)
                    this.prepareMasterProductDetails().then((masterRes:any)=>{

                      this.saveMasterProductDetails(masterRes).then((saveMasterRes:any)=>{

                        this.resetAll(formDirective,printStatus,result.data.insertId)
                      })
                    })
                    // formDirective.resetForm();
                    // this.invoiceForm.reset();
                    // const control = (this.invoiceForm.get('categories') as FormGroup);
                    // control.setControl('products', this.formBuilder.array([]));
                    // this.invoiceForm.setControl('categories', this.formBuilder.array([]));
                    // if(printStatus){
                      //
                      // }
                      // this.createForm()
                      // this.getLastInvoiceId()
                      // this.observables.showToastMessage({type:0,message:"Invoice Created Successfully."})
                    })
                  }else{
                    // this.resetAll(formDirective,printStatus,result.data.insertId)
                    this.prepareMasterProductDetails().then((masterRes:any)=>{

                      this.saveMasterProductDetails(masterRes).then((saveMasterRes:any)=>{

                        this.resetAll(formDirective,printStatus,result.data.insertId)
                      })
                    })
                    // formDirective.resetForm();
                    // this.invoiceForm.reset();
                    // const control = (this.invoiceForm.get('categories') as FormGroup);
                    // control.setControl('products', this.formBuilder.array([]));
                    // this.invoiceForm.setControl('categories', this.formBuilder.array([]));
                    // if(printStatus){
                      //
                      // }
                      // this.createForm()
                      // this.getLastInvoiceId()
                      // this.observables.showToastMessage({type:0,message:"Invoice Created Successfully."})
                    }


                  }else{
                    this.observables.showToastMessage({type:1,message:"Invoice Can\'t Create, Try again..."})
                    this.saveUnsuccess = true;
                    setTimeout(()=>{

                      this.saveUnsuccess = false;
                    },5000)
                  }

                })

          }else{
            this.observables.showToastMessage({type:1,message:"Invoice Can\'t Create in Master, Try again..."})
          }
        })
      }
    })
  }

  addToMaster(value,invoice_date,invoice_id){
    let tags = []
    if(value.tags) {
      value.tags.filter(item=>{
        for(let i=0;i<this.tags.length;i++){
          if(item == this.tags[i].id){
            tags.push({tag_id:this.tags[i].id,tag:this.tags[i].tag_name})
            break;
          }
        }
      })
    }

    return new Promise((resolve)=>{
      this.api.send("insertDb",{
        table:"master_invoices",
        data:{
          business_id:this.business_id,
          invoice_id:invoice_id,
          invoice_number:value.invoice_number,
          party_id:value.party_id,
          party_name:value.party_name,
          gstin:this.party_gstin,
          invoice_date:invoice_date,
          user_name:this.loggedUserInfo.username,
          exclude_gst_total_amount:value.total_amount,
          total_amount: parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
          gst_total_amount:value.gst_total_amount,
          balance:  parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
          delivery_to: value.delivery_to,
          note:value.note,
          user_id:value.user_id,
          tags:(tags.length)?JSON.stringify(tags):null
        }
      }).then((result:any)=>{
        // console.log("master result=",result)
        if(result.data.affectedRows){
          resolve({status:true,master_invoice_id:result.data.insertId});
        }else{
          resolve({status:false});

        }
      })
    })
  }

  saveMasterProductDetails(data){
    console.log("master Data prepared=",data)
    return new Promise((resolve)=>{

      let k=0;

      this.masterInvoiceProductsIterateSubscriber = this.masterInvoiceProductsIterationObserver.subscribe((k)=>{
        if(k>=data.length){
          this.masterInvoiceProductsIterateSubscriber.unsubscribe()
          resolve(true);
        }else{
          this.api.send("insertDb",{
            table:"master_invoice_products",
            data:data[k]
          }).then((result:any)=>{
            // console.log("master product details result=",result)
            if(result.data.affectedRows){

              this.masterInvoiceProductsIterationObserver.next(k+1);
            }else{
              this.masterInvoiceProductsIterationObserver.next(k+1);
            }
          })

        }
      })

      this.masterInvoiceProductsIterationObserver.next(k)

    })
  }
  prepareMasterProductDetails(){
    console.log("preparing=",this.productDetails)

    return new Promise((resolve)=>{
      let k=0;
      let data = []
      this.masterCategoryIterateSubscriber = this.masterCategoryIterationObserver.subscribe((k)=>{
        if(k>=this.productDetails[0].categories.length){
          this.masterCategoryIterateSubscriber.unsubscribe()
          resolve(data)
        }else{
          this.productDetails[0].categories[k].master_invoice_id = this.productDetails[0].master_invoice_id;

          this.getProductDetails(this.productDetails[0].categories[k].products).then((res:any)=>{
            delete this.productDetails[0].categories[k].products
            // console.log("ccc=",this.productDetails[0].categories[k])
            // console.log("rrr=",res)
            // for(let i=0;i<res.length;i++){
            //   data.push(this.prepareObject([this.productDetails[0].categories[k],res[i]]))
            //   if(i == res.length - 1){
            //
            //     this.masterCategoryIterationObserver.next(k+1);
            //   }
            // }

            let i = 0
            this.prepareProductsIterateSubscriber = this.prepareProductsIterationObserver.subscribe((i)=>{
              if(i >= res.length){
                this.prepareProductsIterateSubscriber.unsubscribe()
                this.masterCategoryIterationObserver.next(k+1);
              }else{
                data.push(this.prepareObject([this.productDetails[0].categories[k],res[i]]))
                this.prepareProductsIterationObserver.next(i+1)
              }
            })

            this.prepareProductsIterationObserver.next(i)
            // console.log("saddsad=",this.prepareObject([this.productDetails[0].categories[k],res[0]]))
            // data.push(this.prepareObject([this.productDetails[0].categories[k],res[0]]))
          })
        }
      })

      this.masterCategoryIterationObserver.next(k)

    })
  }

  getProductDetails(products){
    console.log("products=",products)
    return new Promise((resolve)=>{
      let k=0;
      let productArr = []
      this.masterProductIterateSubscriber = this.masterProductIterationObserver.subscribe((k)=>{
        if(k>=products.length){
          this.masterProductIterateSubscriber.unsubscribe()
          resolve(productArr)
        }else{

          this.getVariableDetails(products[k].variables).then((res3:any)=>{
            delete products[k].variables;
            productArr.push(this.prepareObject([products[k],res3]))
            this.masterProductIterationObserver.next(k+1);
          })
        }
      })

      this.masterProductIterationObserver.next(k)
    })

  }

  prepareObject(arr){
    return arr.reduce(function(result, currentObject) {
        for(var key in currentObject) {
            if (currentObject.hasOwnProperty(key)) {
                result[key] = currentObject[key];
            }
        }
        return result;
    }, {});
  }

  getVariableDetails(variables){
    // console.log("variables===",variables)
    return new Promise((resolve)=>{
      let k=0;
      let unit_variables = []
      this.masterVariablesIterateSubscriber = this.masterVariablesIterationObserver.subscribe((k)=>{
        if(k>=variables.length){
          this.masterVariablesIterateSubscriber.unsubscribe()
          resolve(this.prepareObject(unit_variables))
        }else{
          unit_variables.push(variables[k])
          this.masterVariablesIterationObserver.next(k+1);

        }
      })

      this.masterVariablesIterationObserver.next(k)
    })
  }


  saveTags(tags,invoice_id){
    return new Promise((resolve)=>{
      let k= 0;
      this.tagIterateSubscriber = this.tagIterationObserver.subscribe((k)=>{
        if(k >= tags.length){
          this.tagIterateSubscriber.unsubscribe()
          resolve(true)
        }else{
          this.api.send("insertDb",{
            table:'slip_invoice_tags',
            data:{
              business_id:this.loggedUserInfo.business_id,
              invoice_id:invoice_id,
              tag_id:tags[k]
            }
          }).then((res:any)=>{

            this.tagIterationObserver.next(k+1);
          })
        }
      })
      this.tagIterationObserver.next(k)
    })
  }

  removeTags(tags,invoice_id){
    return new Promise((resolve)=>{
      let k= 0;
      this.tagIterateSubscriber = this.tagIterationObserver.subscribe((k)=>{
        if(k >= tags.length){
          this.tagIterateSubscriber.unsubscribe()
          resolve(true)
        }else{
          this.api.send("deleteDb",{
            table:'slip_invoice_tags',
            conditions:[{invoice_id:invoice_id,tag_id:tags[k]}]
          }).then((res:any)=>{

            this.tagIterationObserver.next(k+1);
          })
        }
      })
      this.tagIterationObserver.next(k)
    })
  }

  cancelUpdate(){
    this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])
  }

  updateInvoice(formValue,formDirective:FormGroupDirective){
    if(confirm("Are you sure to update new changes in Invoice?")){
      let value = this.invoiceForm.getRawValue();

      let date:any = new Date(value.invoice_date);
      let invoice_date:any=this.datePipe.transform(date, 'yyyy-MM-dd'); //whatever format you need.

      this.api.send("updateDb",{
        table:"invoices",
        data:{
          invoice_number:value.invoice_number,
          party_id:value.party_id,
          invoice_date:invoice_date,
          gst_total_amount:value.gst_total_amount,
          exclude_gst_total_amount: value.total_amount,
          total_amount: parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
          balance:  parseFloat(value.gst_total_amount) + parseFloat(value.total_amount),
          delivery_to:value.delivery_to,
          user_id:value.user_id,
          note:value.note
        },
        conditions:[{id:this.editInvoiceId}]
      }).then((result:any)=>{
        if(result.data.affectedRows){
          this.editCategory(value.categories).then((categoryRes:any)=>{
            if(categoryRes){
              if(value.tags){
                if(this.editTags.length > 0){
                  let intersectionArr = _.intersection(value.tags,this.editTags);
                  // console.log("intersection=",_.intersection(value.tags,this.editTags));
                  let differenceArr1 = _.difference(value.tags,intersectionArr)
                  // console.log("differenceArr1==",differenceArr1)
                  let differenceArr2 = _.difference(this.editTags,intersectionArr)
                  // console.log("differenceArr2==",differenceArr2)
                  if(differenceArr1.length > 0 && differenceArr2.length > 0){
                    //add from diff1 and remove from diff2
                    this.saveTags(differenceArr1,this.editInvoiceId).then((res:any)=>{
                      this.removeTags(differenceArr2,this.editInvoiceId).then((res1:any)=>{
                        this.resetAll(formDirective)
                      })
                    })
                  }else if(differenceArr1.length == 0 && differenceArr2.length == 0){
                    //tags not updated same as before
                    this.resetAll(formDirective)
                  }else if(differenceArr1.length > 0 && differenceArr2.length == 0){
                    //add from diff1
                    this.saveTags(differenceArr1,this.editInvoiceId).then((res:any)=>{
                      this.resetAll(formDirective)
                    })
                  }else if(differenceArr1.length == 0 && differenceArr2.length > 0){
                    //remove from diff2
                    this.removeTags(differenceArr2,this.editInvoiceId).then((res1:any)=>{
                      this.resetAll(formDirective)
                    })
                  }
                }else{
                  //update all
                  this.saveTags(value.tags,this.editInvoiceId).then((res:any)=>{
                    this.resetAll(formDirective)
                  })
                }
              }else{
                if(this.editTags.length > 0){
                  //remove all tags
                  this.removeTags(this.editTags,this.editInvoiceId).then((res1:any)=>{
                    this.resetAll(formDirective)
                  })
                }else{
                  this.resetAll(formDirective)
                }
              }
            }else{
              this.observables.showToastMessage({type:0,message:'Invoice Not Updated, Try again...'});
            }

          })
        }
      })
    }
  }

  resetAll(formDirective,printStatus=false,invoice_id=null){
    // console.log("in reset")
    formDirective.resetForm();
    this.invoiceForm.reset();
    const control = (this.invoiceForm.get('categories') as FormGroup);
    control.setControl('products', this.formBuilder.array([]));
    this.invoiceForm.setControl('categories', this.formBuilder.array([]));

    this.addCategory();
    // .then(()=>{
    //
    //   this.addProduct((this.invoiceForm.get("categories") as FormArray).controls,0);
    // })
    if(this.editStatus){
      this.editStatus = false;
      this.editOnceStatus = false;
      this.observables.showToastMessage({type:0,message:'Invoice Updated...'});
      this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])
    }else{

      this.invoiceForm.patchValue({invoice_date:moment()})

      this.editStatus = false;
      this.editOnceStatus = false;
      this.loadingStatus = false;
      if(printStatus){

        // this.observables.showSlipViewStatus.next({id:result.data.insertId,invoiceStatus:true,invoiceSlipStatus:true})
        this.api.send("findDb",{
          fields:["I.*, P.*,I.id as id"],
          table:"invoices as I",
          joins:[{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}],
          conditions:[{"I.id":invoice_id}],
          order:"I.id DESC"
        }).then((res:any)=>{
          // console.log("unpaidInvoices==",this.unpaidInvoices)
          this.observables.invoiceViewStatus.next({id:invoice_id,invoiceData:res.data[0]})
        })
      }

      this.getLastInvoiceId()
      this.observables.showToastMessage({type:0,message:"Invoice Created Successfully."})
    }

  }

  getnum(value){
    return parseFloat(value)
  }

  saveCategory(categories,invoiceId){
    return new Promise((resolve)=>{
      let k = 0;
      this.iterateSubscriber = this.iterationObserver.subscribe((k)=>{
        if(k>=categories.length){
            this.iterateSubscriber.unsubscribe();
            resolve(true);
         }else{

           this.api.send("insertDb",{
             table:"categories",
             data:{
               category_name:categories[k].category_name,
               invoice_id:invoiceId
             }
           }).then((categoryRes:any)=>{
             if(categoryRes.data.affectedRows){
               this.productDetails[0].categories.push({category_name:categories[k].category_name,category_id:categoryRes.data.insertId,products:[]})
               this.saveProducts(categories[k].products,invoiceId,categoryRes.data.insertId,this.productDetails[0].categories[k]).then((productRes:any)=>{

                  this.iterationObserver.next(k+1);

               })

             }else{

               resolve(false)
             }
           })
         }
      })

      this.iterationObserver.next(k);
    })
  }
  editCategory(categories){
    return new Promise((resolve)=>{
      let k = 0;
      this.updateCategoryIterateSubscriber = this.updateCategoryIterationObserver.subscribe((k)=>{
        if(k>=categories.length){
            this.updateCategoryIterateSubscriber.unsubscribe();
            if(this.DeletedCategoryRows.length > 0){
              this.deleteCategory(this.DeletedCategoryRows).then((deleteCategoryres:any)=>{
                resolve(true);
              })

            }else{
              resolve(true);
            }
         }else{

           if(categories[k].category_id == ''){
              this.api.send("insertDb",{
                table:"categories",
                data:{
                  category_name:categories[k].category_name,
                  invoice_id:this.editInvoiceId
                }
              }).then((categoryRes:any)=>{
                if(categoryRes.data.affectedRows){

                  this.saveProducts(categories[k].products,this.editInvoiceId,categoryRes.data.insertId).then((productRes:any)=>{

                       this.updateCategoryIterationObserver.next(k+1);

                  })

                }else{

                  resolve(false)
                }

              })

           }else{

             this.api.send("updateDb",{
               table:"categories",
               data:{
                 category_name:categories[k].category_name
               },
               conditions:[{
                 id:categories[k].category_id,
                 invoice_id:this.editInvoiceId
               }]
             }).then((categoryRes:any)=>{
               if(categoryRes.data.affectedRows){
                 this.updateProducts(categories[k].products,categories[k].category_id).then((productRes:any)=>{

                      this.updateCategoryIterationObserver.next(k+1);

                 })

               }else{

                 resolve(false)
               }
             })

           }
         }
      })

      this.updateCategoryIterationObserver.next(k);
    })
  }
  deleteCategory(deletingCategories){
    return new Promise((resolve)=>{
      let k = 0;
      this.deleteCategoryIterateSubscriber = this.deleteCategoryIterationObserver.subscribe((k)=>{
        if(k>=deletingCategories.length){
          this.deleteCategoryIterateSubscriber.unsubscribe();
            resolve(true);
         }else{
           this.api.send("deleteDb",{
             table:"categories",
             conditions:[{
               id:deletingCategories[k],
               invoice_id:this.editInvoiceId
             }]
           }).then((delRes:any)=>{
             if(delRes.data.affectedRows){
               this.api.send("deleteDb",{
                 table:"product_details",
                 conditions:[{
                   category_id:deletingCategories[k]
                 }]
               }).then((delResult:any)=>{
                 this.api.send("deleteDb",{
                   table:"product_unit_variables",
                   conditions:[{
                     category_id:deletingCategories[k]
                   }]
                 }).then((delVariable:any)=>{

                   this.deleteCategoryIterationObserver.next(k+1);
                 })
               })
             }else{

               resolve(false)
             }
           })
         }
      })

      this.deleteCategoryIterationObserver.next(k);
    })
  }
  deleteProducts(deletingProducts){
    return new Promise((resolve)=>{
      let k = 0;
      this.deleteProductIterateSubscriber = this.deleteProductIterationObserver.subscribe((k)=>{
        if(k>=deletingProducts.length){
          this.deleteProductIterateSubscriber.unsubscribe()
            resolve(true);
         }else{

           this.api.send("findDb",{
             table:"categories",
             conditions:[{id:deletingProducts[k].category_id}]
           }).then((delRes:any)=>{
             if(delRes.data.length > 0){
               this.api.send("deleteDb",{
                 table:"product_details",
                 conditions:[{
                   category_id:deletingProducts[k].category_id,
                   id:deletingProducts[k].product_id
                 }]
               }).then((delResult:any)=>{
                 this.api.send("deleteDb",{
                   table:"product_unit_variables",
                   conditions:[{
                     product_detail_id:deletingProducts[k].product_id
                   }]
                 }).then((variableDelRes:any)=>{

                   this.deleteProductIterationObserver.next(k+1);
                 })
               })
             }else{

               this.deleteProductIterationObserver.next(k+1);
             }
           })
         }
      })

      this.deleteProductIterationObserver.next(k);
    })
  }


  saveProducts(products,invoiceId,categoryId,category=null){
    console.log("products===",products)
    return new Promise((resolve)=>{
      let a = 0
      this.productSubscriber = this.productObserver.subscribe((a)=>{
        if(a>=products.length){
          this.productSubscriber.unsubscribe();
          resolve({status:true,products:category.products})
        }else{
          let gst_amount = parseFloat(products[a].amount)/100*products[a].gst;
             this.api.send("insertDb",{
               table:"product_details",
               data:{
                 invoice_id:invoiceId,
                 category_id:categoryId,
                 item_id:products[a].item,
                 description:products[a].description,
                 hsn_code:products[a].hsn_code,
                 qty:products[a].qty,
                 rate:products[a].rate,
                 discount:products[a].discount,
                 amount:products[a].amount
               }
             }).then((result2:any)=>{
             if(result2.data.affectedRows){
               category.products.push({
                 product_detail_id:result2.data.insertId,
                 item_id:products[a].item,
                 item_name:products[a].item_name,
                 item_code:products[a].item_code,
                 hsn_code:products[a].hsn_code,
                 gst:products[a].gst,
                 cess:0,
                 item_description:products[a].description,
                 rate:products[a].rate,
                 unit:products[a].unit,
                 discount:products[a].discount,
                 gross_amount:parseFloat(products[a].amount),
                 sgst:(this.loggedUserInfo.gstin.substring(0,2) == this.party_gstin.substring(0,2))?gst_amount/2:0,
                 cgst:(this.loggedUserInfo.gstin.substring(0,2) == this.party_gstin.substring(0,2))?gst_amount/2:0,
                 igst:(this.loggedUserInfo.gstin.substring(0,2) != this.party_gstin.substring(0,2))?gst_amount:0,
                 net_amount:parseFloat(products[a].amount) + gst_amount,
                 variables:[]
               })

               console.log("category.products[a]===",category.products[a])
               if(products[a].demoArray.length > 1){
                 this.setArrayForUnitVariable(products[a].demoArray,result2.data.insertId,categoryId,false,category.products[a]).then((arrayRes:any)=>{
                   category.products[a].variables = arrayRes.variables
                   this.productObserver.next(a+1);
                 })
               }else{
                 this.productObserver.next(a+1);
               }

             }else{

               resolve(false);
             }

           })

        }

      })

      this.productObserver.next(a);
    })
  }

  //----------------------------

  setArrayForUnitVariable(unitVariableArray,productId, categoryId,updateStatus=false,products=null){
    // console.log("unitVariableArray===",unitVariableArray)
    // console.log("productId===",productId)
    // console.log("categoryId===",categoryId)
    // console.log("updateStatus===",updateStatus)
    // console.log("products===",products)
    
    return new Promise((resolve,reject)=>{
      // this.arrayUnitVariableIterateSubscriber
      let a = 0
      this.arrayUnitVariableIterateSubscriber = this.arrayUnitVariableIterationObserver.subscribe((a)=>{
        if(a>=unitVariableArray.length-1){
          this.arrayUnitVariableIterateSubscriber.unsubscribe();
          if(this.DeletedUnitVariableRows.length > 0 && updateStatus){

            this.deleteUnitVariables(this.DeletedUnitVariableRows).then((delRes:any)=>{

              resolve({status:true,variables_status:false})
            })
          }else{
            if(products){

              resolve({status:true,variables_status:true,variables:products.variables})
            }else{

              resolve({status:true,variables_status:false})
            }
          }
        }else{
          // console.log("unitVariableArray[a]==",unitVariableArray[a])
          let data={};
          // let kyz = Object.keys(unitVariableArray[a])[0];
          // console.log("kyz==",kyz)
          data["category_id"] = categoryId;
          data["product_detail_id"] = productId;
          data["unit_variable_id"]=unitVariableArray[a].unit_variable_id;
          data["unit_variable_value"]=unitVariableArray[a][unitVariableArray[a].key];

          if(unitVariableArray[a].product_variable_id == ''){
            // if(updateStatus){

              //old new insert
              this.saveUnitVariables(data).then((variableRes:any)=>{

                products.variables.push({product_variable_id:variableRes,['col_'+(a+1)]:unitVariableArray[a].key,['col_'+(a+1)+'_value']:unitVariableArray[a][unitVariableArray[a].key]})
                products.unit_value = unitVariableArray[unitVariableArray.length - 1][products.unit]
                this.arrayUnitVariableIterationObserver.next(a+1);

              })
            // }else{
            //
            //   //new insert
            // }
          }else{

            //update
            this.updateUnitVariable(data,unitVariableArray[a].product_variable_id).then((variableRes:any)=>{


              this.arrayUnitVariableIterationObserver.next(a+1);

            })
          }

        }

      })

      this.arrayUnitVariableIterationObserver.next(a);
    })
  }

  updateUnitVariable(data,product_variable_id){
    return new Promise((resolve)=>{

      this.api.send("updateDb",{
        table:"product_unit_variables",
        data:data,
        conditions:[{id:product_variable_id}]
      }).then((result2:any)=>{
        if(result2.data.affectedRows){
          resolve(true)
        }
      })
    })
  }
  deleteUnitVariables(data){
    return new Promise((resolve)=>{
      let a = 0;
      this.deleteUnitVariableIterateSubscriber = this.deleteUnitVariableIterationObserver.subscribe((a)=>{
        if(a >= data.length){
          this.deleteUnitVariableIterateSubscriber.unsubscribe()
          resolve(true)
        }else{
          this.api.send("deleteDb",{
            table:"product_unit_variables",
            conditions:[{id:data[a]}]
          }).then((result2:any)=>{
              this.deleteUnitVariableIterationObserver.next(a+1);
          })
        }
      })
      this.deleteUnitVariableIterationObserver.next(a)

    })
  }

  saveUnitVariables(data){
    // console.log("unitVariables data=",data)
    return new Promise((resolve)=>{
      this.api.send("insertDb",{
        table:"product_unit_variables",
        data:data
      }).then((result2:any)=>{
        if(result2.data.affectedRows){
          resolve(true)
        }
      })
    })
  }
  //----------------------------
  updateProducts(products,categoryId){
    return new Promise((resolve)=>{
      let a = 0
      this.updateProductIterateSubscriber = this.updateProductIterationObserver.subscribe((a)=>{
        if(a>=products.length){
          this.updateProductIterateSubscriber.unsubscribe();
          if(this.DeletedProductRows.length > 0){

            this.deleteProducts(this.DeletedProductRows).then((deleteProductRes:any)=>{

              resolve(true)
            })
          }else{

            resolve(true)
          }
        }else{
          if(products[a].product_id == ''){

             this.api.send("insertDb",{
               table:"product_details",
               data:{
                 invoice_id:this.editInvoiceId,
                 category_id:categoryId,
                 item_id:products[a].item,
                 hsn_code:products[a].hsn_code,
                 description:products[a].description,
                 qty:products[a].qty,
                 rate:products[a].rate,
                 discount:products[a].discount,
                 amount:products[a].amount
               }
             }).then((result2:any)=>{
               if(result2.data.affectedRows){

                 if(products[a].demoArray.length > 1){
                   this.setArrayForUnitVariable(products[a].demoArray,result2.data.insertId,categoryId).then((arrayRes:any)=>{

                     this.updateProductIterationObserver.next(a+1);
                   })
                 }else{
                   this.updateProductIterationObserver.next(a+1);
                 }

               }else{

                 resolve(false);
               }
             })
           }else{

             this.api.send("updateDb",{
              table:"product_details",
              data:{
                category_id:categoryId,
                item_id:products[a].item,
                hsn_code:products[a].hsn_code,
                description:products[a].description,
                qty:products[a].qty,
                rate:products[a].rate,
                discount:products[a].discount,
                amount:products[a].amount
              },
              conditions:[{
                id:products[a].product_id,invoice_id:this.editInvoiceId
              }]
            }).then((result2:any)=>{
              if(result2.data.affectedRows){

                if(products[a].demoArray.length > 1){
                  this.setArrayForUnitVariable(products[a].demoArray,products[a].product_id,categoryId,true).then((arrayRes:any)=>{

                    this.updateProductIterationObserver.next(a+1);
                  })
                }else{
                  this.updateProductIterationObserver.next(a+1);
                }

              }else{

                resolve(false);
              }

            })
          }

        }

      })

      this.updateProductIterationObserver.next(a);
    })
  }
}
